import { ContractTradeType } from "@/types";
import Switch from "@/components/atoms/Switch";
import Text from "@/components/atoms/Text";
import ContractTradeTypeEnum from "@/constants/enums/ContractTradeTypeEnum";
import { useTranslation } from "react-i18next";

interface Props {
  contractType: ContractTradeType;
  tradingPartnerCompanyName: string;
  currentCompanyName: string;
  value: boolean;
  onChangeIsPaymentReceiverInverted: (value: boolean) => void;
  disabled?: boolean;
}

const InvertPaymentSwitch = ({
  contractType,
  tradingPartnerCompanyName,
  currentCompanyName,
  value,
  onChangeIsPaymentReceiverInverted,
  disabled = false,
}: Props) => {
  const { t } = useTranslation();

  const SwitchLabel = () => {
    const tradingPartnerName = tradingPartnerCompanyName;
    if (contractType === ContractTradeTypeEnum.BUY) {
      return (
        <Text
          data-testid={"invert-payment-switch-label"}
        >{`${tradingPartnerName} ${t("contracts:switchLabelPayment.pays")} ${currentCompanyName} ${t("contracts:switchLabelPayment.toReceive")}`}</Text>
      );
    } else {
      return (
        <Text>{`${currentCompanyName} ${t("contracts:switchLabelPayment.pays")} ${tradingPartnerName} ${t("contracts:switchLabelPayment.toReceive")}`}</Text>
      );
    }
  };

  return (
    <Switch
      data-testid={"invert-payment-switch"}
      label={<SwitchLabel />}
      checked={value}
      disabled={disabled}
      onChange={(e) => onChangeIsPaymentReceiverInverted(e.currentTarget.checked)}
    />
  );
};

export default InvertPaymentSwitch;
